import React, { FC } from 'react';
import styled from 'styled-components';
import { gettext } from '@cranium/i18n';
//eslint-disable-next-line no-restricted-imports
import { Link } from 'react-router-dom';
import { Typography } from 'antd';
import { useDevTools } from '@/shared/devTools';

export const Title = styled.h1`
  color: var(--gray-10);
  text-transform: uppercase;
  font: var(--font-semibold-18);
  margin-bottom: 18px;
`;

const AuthRedirectText = styled(Typography.Text)`
  display: flex;
  align-items: center;
  gap: 6px;
  text-transform: none;
  font: var(--font-regular-14) !important;
`;

export const Register: FC = () => {
  const devtools = useDevTools();
  if (!devtools.signup) return null;
  return (
    <AuthRedirectText>
      {gettext("Don't have an account?")}
      <Link to={'/signup'}>{gettext('Register')}</Link>
    </AuthRedirectText>
  );
};
